import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export default function HoldReasonDialog({ open, onOpenChange, onConfirm, busy }) {
  const [reason, setReason] = useState("");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border-[#e6e5df] rounded-sm" data-testid="hold-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-[#232826]">Place On Hold</DialogTitle>
          <DialogDescription className="text-[#6b6a68]">A reason is required — e.g. "No stock for this board", "Waiting on job to return".</DialogDescription>
        </DialogHeader>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} placeholder="Why is this on hold?"
          data-testid="hold-reason-input" className="bg-white border-[#cfcfc9] rounded-sm resize-none text-[#232826]" />
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} className="rounded-sm" data-testid="hold-cancel">Cancel</Button>
          <Button disabled={!reason.trim() || busy} onClick={() => { onConfirm(reason.trim()); setReason(""); }} data-testid="hold-confirm"
            className="bg-orange-500 hover:bg-orange-600 text-white rounded-sm uppercase text-xs tracking-widest">Confirm hold</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
